export const SET_SHOW_LOGIN_POPUP = 'SET_SHOW_LOGIN_POPUP';